import { render, staticRenderFns } from "./SidebarEditing.vue?vue&type=template&id=550a545a&scoped=true&"
import script from "./SidebarEditing.vue?vue&type=script&lang=js&"
export * from "./SidebarEditing.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditing.vue?vue&type=style&index=0&id=550a545a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a545a",
  null
  
)

export default component.exports